import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

interface Props {
  runId: string;
  forcePTUs: boolean;
}

export const useUpdateRun = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateRun = async (data: Props) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data: { forcePTUs: data.forcePTUs },
    });

    await fetch(`${APIBaseChronos}/api/run/${data.runId}`, fetchConfig);
  };

  return useMutation({
    mutationFn: updateRun,
    onSuccess: () => {
      toast.success('Run updated successfully');
      queryClient.invalidateQueries([QueryEntity.ActiveRuns]);
    },
    onError: () => {
      toast.error('Failed to update run');
    },
  });
};
